import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import CCTV from "./pages/CCTV";
import Housekeeping from "./pages/Housekeeping";
import Security from "./pages/Security";
import Contact from "./pages/Contact";
import SocietyProfile from './pages/SocietyProfile';
import Login from './pages/Login'; 

// --- Layout Helper: Sirf Login aur Society Profile par Navbar/Footer chhupayenge ---
const LayoutWrapper = ({ children }) => {
  const location = useLocation();
  
  // Ab sirf in do paths par Navbar aur Footer nahi dikhega
  const hideLayout = [
    "/login",
    "/society" // Isse /society/:id wale sabhi routes cover ho jayenge
  ].some(path => location.pathname.startsWith(path));

  return (
    <>
      {!hideLayout && <Navbar />}
      <div className="main-content">
        {children}
      </div>
      {!hideLayout && <Footer />}
    </>
  );
};

function App() {
  return (
    <Router>
      <LayoutWrapper>
        <Routes>
          {/* Public Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/cctv" element={<CCTV />} />
          <Route path="/housekeeping" element={<Housekeeping />} />
          <Route path="/security" element={<Security />} />
          <Route path="/contact" element={<Contact />} />

          {/* Login & Portal */}
          <Route path="/login" element={<Login />} />
          <Route path="/society/:id" element={<SocietyProfile />} />
          
        </Routes>
      </LayoutWrapper>
    </Router>
  );
}

export default App;